import React from "react";
import { CLIENTS } from "../data/siteData";

export const ClientsBand = () => {
  const items = [...CLIENTS, ...CLIENTS];
  return (
    <section data-testid="clients-band" className="bg-[#0A0A0A] border-b border-[#2E2820] py-14 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 mb-8 reveal">
        <span className="text-[#D4A537] font-semibold uppercase tracking-wider text-sm">Ils nous font confiance</span>
      </div>
      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#0A0A0A] to-transparent z-10" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#0A0A0A] to-transparent z-10" />
        <div className="marquee-track flex w-max">
          {items.map((nom, i) => (
            <span
              key={i}
              data-testid={i < CLIENTS.length ? `client-logo-${nom.toLowerCase().replace(/\s+/g, "-")}` : undefined}
              aria-hidden={i >= CLIENTS.length}
              className="gold-text font-['Oswald'] text-3xl md:text-4xl font-bold tracking-[0.2em] whitespace-nowrap pr-16 opacity-80 hover:opacity-100 transition-opacity"
            >
              {nom}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
